export function truncateToOneDecimalPlace(value: number) {
    if (value == null) {
        return 'N/A'
    }
    return (Math.floor(value * 10) / 10).toFixed(1)
}
